var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCopyToClipboard28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09034 6.66533C7.09077 6.4603 7.25694 6.29428 7.46184 6.29398H9.22229V6.97506C9.22287 7.20213 9.31335 7.41976 9.47386 7.5803C9.63452 7.74082 9.85215 7.83115 10.0793 7.83159H16.334C16.561 7.83144 16.779 7.74125 16.9396 7.58059C17.1003 7.42008 17.1906 7.2023 17.1909 6.97509V6.29401H18.9531C19.1578 6.29445 19.3237 6.46033 19.3242 6.66507V21.9882C19.3237 22.1929 19.1578 22.3587 18.9531 22.3591H7.46186C7.25727 22.3587 7.09139 22.1929 7.09081 21.9882L7.09034 6.66533ZM16.3729 3.5H10.0395C9.81941 3.51059 9.61179 3.60527 9.45967 3.76462C9.30742 3.92398 9.22231 4.13582 9.22187 4.35609V5.03702H7.46186C7.0302 5.03746 6.61623 5.20914 6.311 5.51435C6.00563 5.81972 5.83393 6.23355 5.83337 6.66537V21.9881C5.83381 22.4199 6.00549 22.8339 6.31085 23.1393C6.61607 23.4447 7.03005 23.6164 7.46186 23.6168H18.9531C19.3846 23.6162 19.7983 23.4445 20.1034 23.1393C20.4083 22.8341 20.5797 22.4202 20.5798 21.9886V6.66544C20.5797 6.23377 20.4083 5.81996 20.1034 5.51472C19.7983 5.20935 19.3846 5.03754 18.9531 5.0371H17.1909V4.35617C17.1908 4.13577 17.1056 3.92391 16.9534 3.76444C16.8011 3.60508 16.5932 3.51029 16.3729 3.5ZM10.4794 4.75685V6.57428H15.9331V4.75685H10.4794Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyToClipboard28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;